// src/components/Chat/MiraalMonogram.tsx
// Icon-family 'M' monogram shown before every assistant message. Spins while
// the response is being generated, sits still once it's done - replaces the
// old three-dot TypingIndicator as the live "thinking" state.
import React from 'react';

export const MiraalMonogram: React.FC<{
  size?: number;
  spinning?: boolean;
  className?: string;
}> = ({ size = 18, spinning = false, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 34 34"
    className={`${spinning ? 'miraal-monogram-spin' : ''}${className ? ` ${className}` : ''}`}
    style={{ flexShrink: 0 }}
    aria-hidden="true"
  >
    <rect x="4" y="6" width="5" height="22" fill="#8B5CF6" />
    <rect x="25" y="6" width="5" height="22" fill="#8B5CF6" />
    <path d="M9 6 L17 20 L25 6" stroke="#ECECEF" strokeWidth="5" fill="none" strokeLinejoin="round" />
  </svg>
);
